var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGiftEmptyGrayIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 201,
    height: 200,
    viewBox: "0 0 201 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12841_1382)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 200,
    height: 200,
    transform: "translate(0.5)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.0679 36.878C52.0679 34.1838 54.2519 32 56.946 32H129.42C132.114 32 134.298 34.1838 134.298 36.878C134.298 39.5723 132.114 41.7561 129.42 41.7561H114.089C111.395 41.7561 109.211 43.9399 109.211 46.6341C109.211 49.3284 111.395 51.5122 114.089 51.5122H149.629C153.093 51.5122 155.901 54.3201 155.901 57.784C155.901 61.2479 153.093 64.0557 149.629 64.0557H40.2213C36.7574 64.0557 33.9495 61.2479 33.9495 57.784C33.9495 54.3201 36.7574 51.5122 40.2213 51.5122H70.1864C69.5726 51.5122 68.9853 51.3989 68.4443 51.192C70.2779 50.4907 71.5801 48.7145 71.5801 46.6341C71.5801 44.5538 70.2779 42.7776 68.4443 42.0763C68.9853 41.8694 69.5726 41.7561 70.1864 41.7561H56.946C54.2519 41.7561 52.0679 39.5723 52.0679 36.878Z",
    fill: "#F6F8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.688 57.784C158.688 54.3201 161.496 51.5122 164.96 51.5122H177.503C180.967 51.5122 183.775 54.3201 183.775 57.784C183.775 61.2479 180.967 64.0557 177.503 64.0557H164.96C161.496 64.0557 158.688 61.2479 158.688 57.784Z",
    fill: "#F6F8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.2213 73.8118C36.7574 73.8118 33.9495 76.6197 33.9495 80.0836C33.9495 83.5475 36.7574 86.3554 40.2213 86.3554H125.936C129.399 86.3554 132.207 83.5475 132.207 80.0836C132.207 76.6197 129.399 73.8118 125.936 73.8118H40.2213Z",
    fill: "#F6F8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.46864 101.338C7.46864 98.4515 9.80861 96.1115 12.6951 96.1115H55.2038C58.0904 96.1115 60.4303 98.4515 60.4303 101.338C60.4303 104.224 58.0904 106.564 55.2038 106.564H53.1132C50.2267 106.564 47.8868 108.904 47.8868 111.791C47.8868 114.677 50.2267 117.017 53.1132 117.017H86.5627C83.6762 117.017 81.3362 114.677 81.3362 111.791C81.3362 108.904 83.6762 106.564 86.5627 106.564H165.308C168.195 106.564 170.535 108.904 170.535 111.791C170.535 114.677 168.195 117.017 165.308 117.017H151.023C148.136 117.017 145.796 119.357 145.796 122.244C145.796 125.13 148.136 127.47 151.023 127.47H159.037C161.923 127.47 164.263 129.81 164.263 132.697C164.263 135.583 161.923 137.923 159.037 137.923H126.981C129.867 137.923 132.207 140.263 132.207 143.15C132.207 146.036 129.867 148.376 126.981 148.376H85.8659C82.9793 148.376 80.6394 150.716 80.6394 153.603C80.6394 156.489 82.9793 158.829 85.8659 158.829H92.1376C95.0241 158.829 97.3641 161.169 97.3641 164.056C97.3641 166.942 95.0241 169.282 92.1376 169.282H48.9321C46.0455 169.282 43.7056 166.942 43.7056 164.056C43.7056 161.169 46.0455 158.829 48.9321 158.829H49.6289C52.5154 158.829 54.8554 156.489 54.8554 153.603C54.8554 150.716 52.5154 148.376 49.6289 148.376H5.72648C2.83996 148.376 0.5 146.036 0.5 143.15C0.5 140.263 2.83996 137.923 5.72648 137.923H26.6324C23.7459 137.923 21.4059 135.583 21.4059 132.697C21.4059 129.81 23.7459 127.47 26.6324 127.47H27.6777C30.5642 127.47 32.9042 125.13 32.9042 122.244C32.9042 119.357 30.5642 117.017 27.6777 117.017H25.2387C22.3522 117.017 20.0122 114.677 20.0122 111.791C20.0122 108.904 22.3522 106.564 25.2387 106.564H12.6951C9.80861 106.564 7.46864 104.224 7.46864 101.338Z",
    fill: "#F6F8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.033 106.564C179.147 106.564 176.807 108.904 176.807 111.791C176.807 114.677 179.147 117.017 182.033 117.017H195.274C198.16 117.017 200.5 114.677 200.5 111.791C200.5 108.904 198.16 106.564 195.274 106.564H182.033Z",
    fill: "#F6F8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.845 150.467C121.536 150.467 119.664 152.339 119.664 154.648C119.664 156.957 121.536 158.829 123.845 158.829H132.904C135.213 158.829 137.085 156.957 137.085 154.648C137.085 152.339 135.213 150.467 132.904 150.467H123.845Z",
    fill: "#F6F8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.6213 35.5296C54.7602 35.5296 55.6836 36.4528 55.6836 37.5919C55.6836 38.7309 54.7602 39.6542 53.6213 39.6542L41.2475 39.6542C40.1086 39.6542 39.1852 38.7309 39.1852 37.5919C39.1852 36.4528 40.1086 35.5296 41.2475 35.5296L53.6213 35.5296Z",
    fill: "#D4DDEC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.936 35.5296C32.0749 35.5296 32.9983 36.4528 32.9983 37.5919C32.9983 38.7309 32.0749 39.6542 30.936 39.6542L18.5622 39.6542C17.4233 39.6542 16.4999 38.7309 16.4999 37.5919C16.4999 36.4528 17.4233 35.5296 18.5622 35.5296L30.936 35.5296Z",
    fill: "#D4DDEC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.154 55.1214C38.154 56.2605 37.2306 57.1837 36.0917 57.1837C34.9528 57.1837 34.0294 56.2605 34.0294 55.1214L34.0294 42.7476C34.0294 41.6086 34.9528 40.6853 36.0917 40.6853C37.2306 40.6853 38.154 41.6086 38.154 42.7476L38.154 55.1214Z",
    fill: "#D4DDEC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.154 32.4361C38.154 33.5751 37.2306 34.4984 36.0917 34.4984C34.9528 34.4984 34.0294 33.5751 34.0294 32.4361L34.0294 20.0623C34.0294 18.9233 34.9528 18 36.0917 18C37.2306 18 38.154 18.9233 38.154 20.0623L38.154 32.4361Z",
    fill: "#D4DDEC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.895 121.312C187.32 120.887 188.01 120.887 188.435 121.312C188.86 121.737 188.86 122.426 188.435 122.851L183.817 127.469C183.392 127.894 182.703 127.894 182.278 127.469C181.852 127.044 181.852 126.354 182.278 125.929L186.895 121.312Z",
    fill: "#D4DDEC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.429 129.778C178.854 129.353 179.544 129.353 179.969 129.778C180.394 130.203 180.394 130.892 179.969 131.317L175.351 135.935C174.926 136.36 174.237 136.36 173.811 135.935C173.386 135.51 173.386 134.821 173.811 134.395L178.429 129.778Z",
    fill: "#D4DDEC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.435 134.395C188.86 134.821 188.86 135.51 188.435 135.935C188.01 136.36 187.32 136.36 186.895 135.935L182.278 131.317C181.852 130.892 181.852 130.203 182.278 129.778C182.703 129.353 183.392 129.353 183.817 129.778L188.435 134.395Z",
    fill: "#D4DDEC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.969 125.929C180.394 126.355 180.394 127.044 179.969 127.469C179.544 127.894 178.854 127.894 178.429 127.469L173.811 122.851C173.386 122.426 173.386 121.737 173.811 121.312C174.236 120.887 174.926 120.887 175.351 121.312L179.969 125.929Z",
    fill: "#D4DDEC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.7517 105.088C25.7517 104.487 26.239 104 26.8402 104C27.4413 104 27.9286 104.487 27.9286 105.088V111.619C27.9286 112.22 27.4413 112.707 26.8402 112.707C26.239 112.707 25.7517 112.22 25.7517 111.619V105.088Z",
    fill: "#D4DDEC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.7517 117.061C25.7517 116.46 26.239 115.973 26.8402 115.973C27.4413 115.973 27.9286 116.46 27.9286 117.061V123.592C27.9286 124.193 27.4413 124.68 26.8402 124.68C26.239 124.68 25.7517 124.193 25.7517 123.592V117.061Z",
    fill: "#D4DDEC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.0919 113.252C36.693 113.252 37.1803 113.739 37.1803 114.34C37.1803 114.941 36.693 115.429 36.0919 115.429H29.5612C28.9601 115.429 28.4728 114.941 28.4728 114.34C28.4728 113.739 28.9601 113.252 29.5612 113.252H36.0919Z",
    fill: "#D4DDEC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.1191 113.252C24.7202 113.252 25.2075 113.739 25.2075 114.34C25.2075 114.941 24.7202 115.429 24.1191 115.429H17.5884C16.9873 115.429 16.5 114.941 16.5 114.34C16.5 113.739 16.9873 113.252 17.5884 113.252H24.1191Z",
    fill: "#D4DDEC"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 56.8537,
    cy: 104.354,
    rx: 4.35375,
    ry: 4.35375,
    fill: "#EEF2F5"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 184.854,
    cy: 168.354,
    rx: 4.35375,
    ry: 4.35375,
    fill: "#EEF2F5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M149.384 181.048C153.893 181.048 157.548 177.393 157.548 172.884C157.548 168.376 153.893 164.721 149.384 164.721C144.876 164.721 141.221 168.376 141.221 172.884C141.221 177.393 144.876 181.048 149.384 181.048ZM149.384 183.769C155.396 183.769 160.269 178.896 160.269 172.884C160.269 166.873 155.396 162 149.384 162C143.373 162 138.5 166.873 138.5 172.884C138.5 178.896 143.373 183.769 149.384 183.769Z",
    fill: "#D4DDEC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M89.3844 35.0476C93.8928 35.0476 97.5476 31.3928 97.5476 26.8844C97.5476 22.3759 93.8928 18.7211 89.3844 18.7211C84.8759 18.7211 81.2211 22.3759 81.2211 26.8844C81.2211 31.3928 84.8759 35.0476 89.3844 35.0476ZM89.3844 37.7687C95.3956 37.7687 100.269 32.8956 100.269 26.8844C100.269 20.8731 95.3956 16 89.3844 16C83.3731 16 78.5 20.8731 78.5 26.8844C78.5 32.8956 83.3731 37.7687 89.3844 37.7687Z",
    fill: "#D4DDEC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.5945 159.885H137.035C142.135 159.885 146.27 155.688 146.27 150.512V103.642H54.3594V150.512C54.3594 155.688 58.4944 159.885 63.5945 159.885Z",
    fill: "url(#paint0_linear_12841_1382)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 54.3594,
    y: 103.642,
    width: 91.9103,
    height: 6.85897,
    fill: "#C3C7D8",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.4423 81.6933L57.0574 81.6934C51.7787 81.6934 47.5 85.8891 47.5 91.0643V99.5797C47.5 101.823 49.3553 103.642 51.6427 103.642H150.357C152.647 103.642 154.5 101.823 154.5 99.5797V91.0643C154.5 85.8891 150.221 81.6934 144.943 81.6934H117.371L85.4423 81.6933Z",
    fill: "url(#paint1_linear_12841_1382)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M120.83 81.6929H82.544C69.6393 79.9251 53.8447 68.6574 57.6891 56.7681C61.1868 45.9484 71.6822 40.476 82.4123 40.5396C97.5596 40.6209 101.483 70.6765 101.483 70.6765H101.889C101.889 70.6765 105.815 40.6209 120.96 40.5396C131.685 40.476 142.183 45.9484 145.681 56.7681C149.525 68.6574 133.73 79.9251 120.83 81.6929ZM132.098 51.4635C132.098 51.4635 131.628 66.2545 110.631 77.3004C110.631 77.3004 114.601 58.3114 132.098 51.4635ZM71.4518 51.4635C88.9426 58.3092 92.9099 77.3004 92.9099 77.3004C71.917 66.2545 71.4518 51.4635 71.4518 51.4635Z",
    fill: "url(#paint2_linear_12841_1382)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_12841_1382",
    x1: 99.001,
    y1: 96.0005,
    x2: 101.501,
    y2: 166.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D5DDE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E0E7F4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_12841_1382",
    x1: 101.5,
    y1: 83.001,
    x2: 104.5,
    y2: 109.501,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFF5FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DFE5F0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_12841_1382",
    x1: 101.685,
    y1: 40.5391,
    x2: 101.685,
    y2: 81.6929,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E0E6F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C5CEDE"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12841_1382"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 200,
    height: 200,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGiftEmptyGrayIcon);
export default __webpack_public_path__ + "static/media/gift-empty-gray-icon.d68b68ed832e90c1b035c3bc9745192f.svg";
export { ForwardRef as ReactComponent };